import React, { useContext, useEffect } from 'react'
import { StateContext } from '../services/StateService'
import { getSpecificationsLabel } from '../services/PDPService'
import { Translations } from '../services/TranslationService'
import { trackDataOnLoad } from '../services/TealiumService'
import { addChildrenStructuredData } from '../services/PDPSEOService.jsx'
import BreadCrumbList from '../fragments/BreadCrumbList.jsx'
import Header from '../fragments/DetailPage/Header'
import BuyingZone from '../fragments/DetailPage/BuyingZone'
import Specifications from '../fragments/DetailPage/Specifications'
import Details from '../fragments/DetailPage/Details'
import Resources from '../fragments/DetailPage/Resources'
import Support from '../fragments/DetailPage/Support'
import DisclaimerInformation from '../fragments/DetailPage/DisclaimerInformation'
import Reviews from '../fragments/DetailPage/Reviews'
import RelatedProducts from '../fragments/DetailPage/RelatedProducts.jsx'
import MediaGalleryScripts from '../components/MediaGalleryScripts'
import RichContent from '../components/RichContent'
import SimilarProducts from '../fragments/DetailPage/SimilarProducts.jsx'
import RequiredProducts from '../fragments/DetailPage/RequiredProducts.jsx'
import StickyNavigation from '../fragments/DetailPage/StickyNavigation.jsx'
import '../css/PDP.scss'

// TODO Add testing
/* istanbul ignore next */
const PDP = () => {
    const {
        breadCrumb,
        productDetails,
        richContent,
        classificationAttributes,
        locale,
        displayController,
        childrenSeo
    } = useContext(StateContext)
    const translations = useContext(Translations)

    const specificationsLabel = getSpecificationsLabel(
        locale,
        productDetails?.divisionCode,
        translations?.specifications,
        translations?.specificationsAlternate
    )

    const handleAnchorScroll = () => {
        const hash = window.location.hash
        if (!hash) return

        const targetId = hash.slice(1)

        const observer = new MutationObserver(() => {
            const target = document.getElementById(targetId)
            if (target) {
                observer.disconnect()
                // Wait 2s for dynamic content to settle, then scroll on the next paint cycle
                setTimeout(() => {
                    // ensure scroll happens after any potential layout shifts
                    requestAnimationFrame(() => {
                        target.scrollIntoView({ behavior: 'smooth' })
                    })
                }, 2000)
            }
        })

        observer.observe(document.body, { childList: true, subtree: true })
        setTimeout(() => observer.disconnect(), 5000) // safety to prevent infinite observing
    }

    useEffect(() => {
        trackDataOnLoad('PDP page onload', 'Engagement Event', { product_views: 1 })
        childrenSeo && addChildrenStructuredData(productDetails, childrenSeo)
        handleAnchorScroll()
    }, [])

    return (
        <section className="sps2-pdp">
            <MediaGalleryScripts />
            {breadCrumb?.length > 0 && <BreadCrumbList breadcrumbsList={breadCrumb} />}
            <Header />
            <StickyNavigation />
            <BuyingZone showDetails={displayController?.showDetails} />
            {displayController?.showRequiredProducts && <RequiredProducts />}
            {richContent?.flexZone && (
                <RichContent richContentObj={richContent.flexZone}></RichContent>
            )}
            {richContent?.flexZone2 && (
                <RichContent richContentObj={richContent.flexZone2}></RichContent>
            )}
            {richContent?.flexZone3 && (
                <RichContent richContentObj={richContent.flexZone3}></RichContent>
            )}
            {displayController?.showDetails && <Details />}
            {displayController?.classificationAttributes && (
                <Specifications
                    classificationAttributes={classificationAttributes}
                    specificationsLabel={specificationsLabel}
                />
            )}
            {displayController?.showResources && <Resources />}
            {displayController?.showReviews && (
                <Reviews productDetails={productDetails} />
            )}
            {displayController?.showSupport && <Support />}
            {displayController?.similarProducts && <SimilarProducts />}
            {displayController?.relatedProducts && <RelatedProducts />}
            <div>
                {/* there is an issue with the rich content, the HTML is broken which endup getting the next element className,
                this div will avoid that, hoepfully we could delete soon */}
            </div>
            {displayController?.showDisclaimerInfo && <DisclaimerInformation />}
            {richContent?.contextualSupportWidget && (
                <RichContent
                    richContentObj={richContent.contextualSupportWidget}
                ></RichContent>
            )}
        </section>
    )
}

export default PDP
